export default "__VITE_ASSET__rWmAOrWR__"